import React from 'react';
import HTMLReactParser from 'html-react-parser';

const Markdown = ({ data, removeStyles, ...other }) => {
  const replace = node => {
    // Remove <p> inside of <li>
    if (node.parent?.name === 'li' && node.children) {
      let html = '';
      node.children.forEach((child, index) => {
        html += index > 0 ? `<br/>${child.data}` : child.data
      })
      return (<>{html}</>)
    }
    // Remove inline styles
    if (node.attribs) {
      let attrs = node.attribs;
      if(attrs.style) {
        attrs.style = null;
      }
      return (node);
    }
  };
  if (removeStyles) {
    return (
      <div {...other}>
        {HTMLReactParser(data, { replace })}
      </div>
    )
  } else {
    return (
      <div {...other}
        dangerouslySetInnerHTML={{
          __html: data
        }}
      />
    )
  }
}

export default Markdown
